import styled from "styled-components";

export const FooterWrapper = styled.footer`
  width: 100%;
  height: 8rem;
  background-color: rgb(26, 26, 26);
  color: rgb(156, 156, 156);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
`;

export const SitesGroup = styled.p`
  margin-top: 1rem;
`;

export const Site = styled.a`
  color: rgb(156, 156, 156);
  padding: 0.8rem;
  &:visited {
    color: rgb(156, 156, 156);
  }
`;
